import wixLocation from 'wix-location';
import { biLoggerFactory } from 'wix-private';
const biLogger = biLoggerFactory('marketplace', 80, { msid: 'c03f75d4-ed73-4244-b7c6-c87ea8828184' });

$w.onReady(async function () {
	try {
		const biEventObject = { evid: 158, typeid: 1 };
		biLogger.log(biEventObject);
	} catch (err) {
		console.log(err, "heree")
	}
});

export async function button22_click(event) {
	try {
		const biEventObject = { evid: 157, origin: 'how it works', typeid: 1 };
		biLogger.log(biEventObject);
	} catch (err) {
		console.log(err, "heree")
	}
	wixLocation.to('https://www.wix.com/arena/dynamic-brief?entry=generalMenu&serviceType=1&innerType=1&origin=arenahow')
}

export async function button_click(event) {
	try {
		const biEventObject = { evid: 156, origin: 'how it works', typeid: 1 };
		biLogger.log(biEventObject);
	} catch (err) {
		console.log(err, "heree")
	}
	wixLocation.to('https://www.wix.com/arena/hire')
}